import { useState, useEffect, useContext } from 'react';

import { cmnContext } from '../../../../common/CmnContext';
import { LiveReserveContext } from '../LiveLessonReseveContext';
import LiveReserveSelectInstructor from './selectInstructor/LiveReserveSelectInstructor';
import LiveReserveMtInstructor from './mtInstructor/LiveReserveMtInstructor';
import LiveReserveTime from './time/LiveReserveTime';
import LiveReserveDate from './date/LiveReserveDate';
import LiveReserveSituation from './situation/LiveReserveSituation';
import LiveReserveRequest from './request/LiveReserveRequest';
import LiveReserveTicketLess from './ticketLess/LiveReserveTicketLess';
import LiveReserveSubmit from './submit/LiveReserveSubmit';
import LiveReserveAccessAlert from './accessAlert/LiveReserveAccessAlert';
import Loading from '../../../../common/loading/Loading';


function LiveReserveForm() {

  const { isPc } = useContext(cmnContext);
  const {
    lessonTermMinute, formRef,
    isCoaching, isLesson, isLoading,
    lsnMin, trialCount, isTicketLess,
    selectedScheduleId, selectedSituation,
  } = useContext(LiveReserveContext);

  // (予約の可否)無料回数/チケットの不足
  const [canReserve, setCanReserve] = useState(false);


  // (予約の可否)無料回数/チケットの不足
  useEffect(() => {
    setCanReserve(
      !isTicketLess || //チケット数
      trialCount >= lsnMin / lessonTermMinute //無料回数
    );
  }, [lsnMin, trialCount, isTicketLess])

  
  return (
    <div style={{ margin: '0 -15px', padding: '15px', backgroundColor: '#f0f0f0' }}>
      <form
        ref={formRef}
        action="/lesson/live"
        method="post"
      >
        <input type="hidden" name="mode" value="1" />
        <input type='hidden' name='sche_id' value={selectedScheduleId} />
        <input type='hidden' name='situation' value={selectedSituation} />

        <div style={{marginBottom: '10px'}}>

          {/* 講師選択 */}
          <LiveReserveSelectInstructor />

          {isCoaching ?
            <>
              {/* MT講師選択(エラー) */}
              <LiveReserveMtInstructor />
            </>
          :
            <>
              {/* 時間選択 */}
              <LiveReserveTime />

              <div>
                {isLesson ?
                  <>
                  {canReserve ?
                    <div>
                      {isLoading ?
                        <>
                          {/* ローディング */}
                          <Loading width={isPc? '5%':'10%'} />
                        </>
                      :
                        <>
                          {/* 日時選択 */}
                          <LiveReserveDate />
                        </>
                      }

                      {/* 内容選択 */}
                      <LiveReserveSituation />

                      {/* 習いたい箇所 */}
                      <LiveReserveRequest />

                      <br className="clearfix" />

                      {/* 予約ボタン */}
                      <LiveReserveSubmit />
                    </div>
                  :
                    <>
                      {/* 無料回数/チケット不足 */}
                      <LiveReserveTicketLess />
                    </>
                  }
                  </>
                :
                  <>
                    {/* アクセス集中アラート */}
                    <LiveReserveAccessAlert />
                  </>
                }
              </div>
            </>
          }

        </div>
      </form>
    </div>
  );
}
  
export default LiveReserveForm;